<template>
  <div>
    <label>Certification Level</label>
    <div>
      <md-chip
        v-for="certificationLevel in availableCertificationLevels"
        :key="certificationLevel"
        :class="{ 'md-primary': isSelected(certificationLevel) }"
        :md-clickable="
          isSelected(certificationLevel) ||
            caseConfCertificationLevels.length < 2
        "
        :md-disabled="
          !isSelected(certificationLevel) &&
            caseConfCertificationLevels.length >= 2
        "
        @click="() => toggleCertificationLevel(certificationLevel)"
      >
        {{ certificationLevel }}
      </md-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'case-certification-levels',
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      availableCertificationLevels: [
        'EMR',
        'EMT',
        'AEMT',
        'Paramedic',
        'Critical Care',
        'RN',
        'RT',
        'Community Paramedic',
      ],
    };
  },
  computed: {
    caseConfCertificationLevels() {
      const { dispatch } = this.caseConf;
      if (!dispatch) {
        return [];
      }
      if (!dispatch.certificationLevels) {
        return [];
      }
      return dispatch.certificationLevels;
    },
  },
  methods: {
    isSelected(certificationLevel) {
      return this.caseConfCertificationLevels.includes(certificationLevel);
    },
    toggleCertificationLevel(certificationLevel) {
      if (this.isSelected(certificationLevel)) {
        this.$emit('update', {
          dispatch: {
            certificationLevels: this.caseConfCertificationLevels.filter(
              (s) => s !== certificationLevel
            ),
          },
        });
        return;
      }
      if (this.caseConfCertificationLevels.length >= 2) {
        return;
      }
      this.$emit('update', {
        dispatch: {
          certificationLevels:
            this.caseConfCertificationLevels.concat(certificationLevel),
        },
      });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-bottom: 10px;
}

.md-chip {
  background-color: #e0e0e0;
  margin-bottom: 10px;
  margin-right: 5px;
}

.md-chip.md-disabled {
  cursor: not-allowed;
}

.md-chip + .md-chip {
  margin-left: unset;
}
</style>